import { getBranchInstance } from '../../../tools/Globals';

import * as D from './deps';

const logger = D.Logger.child({
  component: 'domains/analytics/branchio/utils',
});

export function setIdentity(listenerKruxToken) {
  const branch = getBranchInstance();
  if (branch) {
    branch.setIdentity(listenerKruxToken, function (err, data) {
      if (err) {
        logger.error(err, data);
      }
    });
  }
}

export function logout() {
  const branch = getBranchInstance();
  if (branch) {
    branch.logout(function (err, data) {
      if (err) {
        logger.error(err, data);
      }
    });
  }
}

export function logEvent(
  eventName,
  eventAndCustomData = {},
  contentItems = [],
  customerEventAlias = '',
) {
  const branch = getBranchInstance();
  if (branch) {
    branch.logEvent(
      eventName,
      eventAndCustomData,
      contentItems,
      customerEventAlias,
      function (err) {
        if (err) {
          logger.error(err);
        }
      },
    );
  }
}
